import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManagePricingCategoriesSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailabilityPriceCategory, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Pricing Categories</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Pricing Option</p>
              <p className="text-secondary capitalize">
                {optionData?.pricingOption === "fixed"
                  ? "Price is the same for everyone"
                  : optionData?.pricingOption === "age_group"
                  ? "Price depends on age"
                  : optionData?.pricingOption === "vehicle"
                  ? "Price Per Vehicle"
                  : "N/A"}
              </p>
            </div>
          </div>
          {/* Show pricing categories for age_group or vehicle */}
          {optionData?.pricingOption === "age_group" && (
            <div className="w-full text-sm">
              <div className="space-y-2">
                <p className="font-bold">Pricing Categories</p>
                {(optionData?.pricing || []).map((cat: any, idx: number) => (
                  <div key={idx} className="space-y-1">
                    <p className="text-secondary capitalize">
                      <span className="font-bold">Age Group:</span>{" "}
                      {cat.category}
                      {cat.minAge !== undefined && cat.maxAge !== undefined
                        ? ` (${cat.minAge} - ${cat.maxAge} yrs)`
                        : "N/A"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
          {optionData?.pricingOption === "vehicle" && (
            <div className="w-full text-sm">
              <div className="space-y-2">
                <p className="font-bold">Pricing Categories</p>
                {(optionData?.groupPricing || []).map(
                  (group: any, idx: number) => (
                    <div key={idx} className="space-y-1">
                      <p className="text-secondary capitalize">
                        <span className="font-bold">Group Name:</span>{" "}
                        {group.name}
                      </p>
                      <p className="text-secondary capitalize">
                        Size: {group.from} - {group.to}
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
